import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.QuoteUiAdapter.';
  public static readonly openingQuote = `${Id.prefix}openingQuote`;
  public static readonly pleaseWaitWhileInitializingQuote = `${Id.prefix}pleaseWaitWhileInitializingQuote`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangQuoteUiAdapter {
  private constructor() {}
  public static openingQuote(): string {
    return interpolate(Id.openingQuote);
  }
  public static pleaseWaitWhileInitializingQuote(): string {
    return interpolate(Id.pleaseWaitWhileInitializingQuote);
  }
}

export class QuoteUiAdapterModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.openingQuote, "Opening {{glossary 'quote'}}", 'Message shown when opening a quote');
    register.add(
      Id.pleaseWaitWhileInitializingQuote,
      "please wait while we initialize the {{glossary 'quote'}}",
      'Message shown while initializing a quote'
    );
  }
}
